<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <tb-skeleton v-if="busy_loading" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>
            <div v-else-if="!busy_loading && template">
                <ValidationObserver ref="templateform">
                    <form @submit="saveTemplate">
                        <div class="card">
                            <div class="card-header bg-light">
                                <h6 class="card-title">Mallinställningar</h6>
                            </div>
                            <div class="card-body">
                                <ValidationProvider vid="selection" name="Korturval" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label class="d-block">Malltyp</label>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" class="custom-control-input" name="use_view" id="rdo-use-view" v-model="template.use_view" :value="1" :disabled="template.TemplateID > 0">
                                            <label class="custom-control-label" for="rdo-use-view">Rednax™ Builder</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" class="custom-control-input" name="use_view" id="rdo-use-legacy" v-model="template.use_view" :value="0" :disabled="template.TemplateID > 0">
                                            <label class="custom-control-label" for="rdo-use-legacy">Legacy</label>
                                        </div>
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                                <input-with-validation
                                    v-model="template.TemplateName"
                                    vid="TemplateName"
                                    label="Mallnamn"
                                    rules="required"
                                ></input-with-validation>
                                <input-with-validation
                                    v-model="template.EmailSubject"
                                    vid="EmailSubject"
                                    label="Ämne"
                                    rules="required"
                                ></input-with-validation>
                                <input-with-validation
                                    v-model="template.SenderName"
                                    vid="SenderName"
                                    label="Avsändare Namn"
                                    rules="required"
                                ></input-with-validation>
                                <input-with-validation
                                    v-model="template.SenderEmail"
                                    vid="SenderEmail"
                                    label="Avsändare E-post"
                                    rules="required"
                                ></input-with-validation>

<!--                                <label>Mailfunktioner</label>-->
<!--                                <div>-->
<!--                                    <div class="custom-control custom-checkbox mb-2">-->
<!--                                        <input type="checkbox" class="custom-control-input" id="chk-automatic_sendouts" v-model="template.automatic_sendouts">-->
<!--                                        <label class="custom-control-label" for="chk-automatic_sendouts">Aktivera automatiska utskick</label>-->
<!--                                    </div>-->
<!--                                    <div class="custom-control custom-checkbox mb-2">-->
<!--                                        <input type="checkbox" class="custom-control-input" id="chk-disable_click_tracking" v-model="template.disable_click_tracking">-->
<!--                                        <label class="custom-control-label" for="chk-disable_click_tracking">Avaktivera tracking vid klick i mailet</label>-->
<!--                                    </div>-->
<!--                                    <div class="custom-control custom-checkbox mb-2">-->
<!--                                        <input type="checkbox" class="custom-control-input" id="chk-disable_open_tracking" v-model="template.disable_open_tracking">-->
<!--                                        <label class="custom-control-label" for="chk-disable_open_tracking">Avaktivera tracking vid öppning av mail</label>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                            <div class="card-footer text-right">
                                <div class="d-flex justify-content-end">
                                    <limitless-button ref="btnsavetemplate" @click="saveTemplate" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                                </div>
                            </div>
                        </div>
                        <div v-if="template.use_view">
                            <!-- Use new templates -->
                            <template-editor
                                v-model="template.view"
                                mode="advanced"
                            >
                                <template #footer>
                                    <div class="d-flex justify-content-end">
                                        <limitless-button ref="btnsavetemplate2" @click="saveTemplate" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                                    </div>
                                </template>
                            </template-editor>
                        </div>
                        <div
                            v-else
                            class="card"
                        >
                            <!-- Use old templates -->
                            <div class="card-header bg-light header-elements-inline py-2 border-top">
                                <h6 class="card-title">HTML</h6>
                            </div>
                            <div class="card-body">
                                <ValidationProvider vid="EmailHTML" name="HTML" rules="required" v-slot="{ errors }">
                                    <Editor v-model="template.EmailHTML"></Editor>
                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="card-footer text-right">
                                <div class="d-flex justify-content-end">
                                    <limitless-button ref="btnsavetemplate2" @click="saveTemplate" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>

                <div v-if="!template.use_view" class="card">
                    <div class="card-header bg-light">
                        <h6 class="card-title">Förhandsgranskning</h6>
                    </div>
                    <div class="card-body">
                        <Iframe
                            frameborder="0"
                            style="width: 100%; height: 1800px; overflow-x: hidden;">
                            <div v-html="template.EmailHTML"></div>
                        </Iframe>
                    </div>
                </div>
            </div>
            <div v-else>
                <i>Mallen kunde ej hämtas...</i>
            </div>
        </div>
    </div>
</template>

<script>
import TemplateEditor from '@components/Ecard/TemplateEditor.vue';
import Iframe from '@components/Iframe';
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import Editor from '@components/Editor.vue';

export default {
    name: 'EcardTemplateEdit',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
        InputWithValidation,
        Editor,
        Iframe,
        TemplateEditor,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data() {
        return {
            busy_loading: false,
            busy_saving: false,
            template: null,
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        init() {
            this.getTemplate();
        },
        getTemplate() {
            this.busy_loading = true;
            apiClient.get('/vue/ecard/templates/' + this.id)
                .then((response) => {
                    this.template = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        async saveTemplate() {
            const isValid = await this.$refs.templateform.validate();
            if (isValid) {
                apiClient.post('/vue/ecard/template/' + this.id, this.template)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.TemplateID, 10)) {
                            window.location.href = '/ecard/templates/' + response.data.TemplateID;
                        }
                        this.template = response.data;
                        this.$refs.btnsavetemplate.triggerSaved();
                        this.$refs.btnsavetemplate2.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.templateform.setErrors(parsederror);
                        }
                        this.$refs.btnsavetemplate2.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            } else {
                this.$refs.btnsavetemplate.triggerFailed();
                this.$refs.btnsavetemplate2.triggerFailed();
            }
        },
    },
};
</script>
